/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconArrowIteration = createReactComponent("outline", "arrow-iteration", "IconArrowIteration", [["path", { "d": "M8.5 16a5.5 5.5 0 1 0 -5.5 -5.5v.5", "key": "svg-0" }], ["path", { "d": "M3 16h18", "key": "svg-1" }], ["path", { "d": "M18 13l3 3l-3 3", "key": "svg-2" }]]);

export { IconArrowIteration as default };
//# sourceMappingURL=IconArrowIteration.mjs.map
